// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const JobsHttpDeleteJobs = 'JobsHttpDeleteJobs' as const;
export const JobsHttpGetJobs = 'JobsHttpGetJobs' as const;
export const JobsHttpPatchJobs = 'JobsHttpPatchJobs' as const;
export const JobsHttpPostJobs = 'JobsHttpPostJobs' as const;
export const JobsHttpPutJobsPriority = 'JobsHttpPutJobsPriority' as const;
export const JobsHttpPutJobsState = 'JobsHttpPutJobsState' as const;
export const JobsHttpDeleteJobsByJobId = 'JobsHttpDeleteJobsByJobId' as const;
export const JobsHttpGetJobsByJobId = 'JobsHttpGetJobsByJobId' as const;
export const JobsHttpPatchJobsByJobId = 'JobsHttpPatchJobsByJobId' as const;
export const JobsHttpPutJobsByJobId = 'JobsHttpPutJobsByJobId' as const;
export const JobsHttpPostJobsByJobIdReindex =
  'JobsHttpPostJobsByJobIdReindex' as const;
export const JobsHttpPatchJobsByJobIdSteps =
  'JobsHttpPatchJobsByJobIdSteps' as const;
export const JobsHttpPutJobsByJobIdSteps =
  'JobsHttpPutJobsByJobIdSteps' as const;
export const JobsHttpPatchJobsByJobIdStepsByJobStepId =
  'JobsHttpPatchJobsByJobIdStepsByJobStepId' as const;
export const JobsHttpPutJobsByJobIdStepsByJobStepId =
  'JobsHttpPutJobsByJobIdStepsByJobStepId' as const;

/**
 * Original schema `ActionContextSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-ActionContextSchema}
 */
export interface JobsActionContextSchema {
  ABORT?: JobsActionContextValue;
  CHANGE_PRIORITY?: JobsActionContextValue;
  PAUSE?: JobsActionContextValue;
  RESTART?: JobsActionContextValue;
  RESUME?: JobsActionContextValue;
}
/**
 * Original schema `ActionContextValue`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-ActionContextValue}
 */
export interface JobsActionContextValue {
  bulk?: boolean;
  url?: string;
}
/**
 * Original schema `ActionContextValueSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-ActionContextValueSchema}
 */
export interface JobsActionContextValueSchema {
  bulk?: boolean;
  url?: string;
}
/**
 * Original schema `BaseQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-BaseQueryParamsSchema}
 */
export interface JobsBaseQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `BulkJobCreatedSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-BulkJobCreatedSchema}
 */
export interface JobsBulkJobCreatedSchema {
  job_id?: string;
}
/**
 * Original schema `JobBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobBaseSchema}
 */
export interface JobsJobBaseSchema {
  action_context?: JobsActionContextSchema;
  children_progress?: {
    [k: string]: JobsJobChildProgressSchema;
  };
  completed_at?: string;
  custom_type?: string | null;
  date_created?: string;
  date_modified?: string;
  error_message?: string;
  has_children?: boolean;
  id?: string;
  job_context?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id?: string | null;
  object_type?: string | null;
  parent_id?: string | null;
  priority?: number;
  progress?: number;
  progress_processed?: number;
  progress_total?: number;
  /**
   * @minItems 1
   */
  related_objects?: JobsRelatedObject[];
  started_at?: string;
  status:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
  title: string;
  type:
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING';
}
/**
 * Original schema `JobChildProgressSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobChildProgressSchema}
 */
export interface JobsJobChildProgressSchema {
  progress_processed?: number;
  progress_total?: number;
  status?:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
}
/**
 * Original schema `RelatedObject`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-RelatedObject}
 */
export interface JobsRelatedObject {
  object_id: string;
  object_type: string;
}
/**
 * Original schema `JobCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobCreateSchema}
 */
export interface JobsJobCreateSchema {
  action_context?: JobsActionContextSchema;
  children_progress?: {
    [k: string]: JobsJobChildProgressSchema;
  };
  completed_at?: string;
  created_by?: string;
  custom_type?: string | null;
  date_created?: string;
  date_modified?: string;
  error_message?: string;
  has_children?: boolean;
  id?: string | null;
  job_context?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id?: string | null;
  object_type?: string | null;
  parent_id?: string | null;
  priority?: number;
  progress?: number;
  progress_processed?: number;
  progress_total?: number;
  /**
   * @minItems 1
   */
  related_objects?: JobsRelatedObject[];
  started_at?: string;
  status:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
  steps?: JobsJobStep[];
  title: string;
  type:
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING';
}
/**
 * Original schema `JobStep`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobStep}
 */
export interface JobsJobStep {
  date_updated?: string;
  error_message?: string | null;
  id?: string;
  label: string;
  message?: string | null;
  status: 'IN_PROGRESS' | 'WAITING' | 'FAILED' | 'DONE' | 'SKIPPED';
}
/**
 * Original schema `JobElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobElasticSchema}
 */
export interface JobsJobElasticSchema {
  action_context?: JobsActionContextSchema;
  children_progress?: {
    [k: string]: JobsJobChildProgressSchema;
  };
  completed_at?: string;
  created_by?: string;
  custom_type?: string | null;
  date_created?: string;
  date_modified?: string;
  error_message?: string;
  has_children?: boolean;
  id?: string;
  job_context?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id?: string | null;
  object_type?: string | null;
  parent_id?: string | null;
  priority?: number;
  progress?: number;
  progress_processed?: number;
  progress_total?: number;
  /**
   * @minItems 1
   */
  related_objects?: JobsRelatedObject[];
  started_at?: string;
  status:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
  steps?: JobsJobStepElastic[];
  storage_id?: string;
  title: string;
  type:
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING';
}
/**
 * Original schema `JobStepElastic`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobStepElastic}
 */
export interface JobsJobStepElastic {
  date_updated?: string;
  error_message?: string | null;
  id?: string;
  label: string;
  message?: string | null;
  status?: string;
}
/**
 * Original schema `JobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobSchema}
 */
export interface JobsJobSchema {
  action_context?: JobsActionContextSchema;
  children_progress?: {
    [k: string]: JobsJobChildProgressSchema;
  };
  completed_at?: string;
  created_by?: string;
  custom_type?: string | null;
  date_created?: string;
  date_modified?: string;
  error_message?: string;
  has_children?: boolean;
  id?: string;
  job_context?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id?: string | null;
  object_type?: string | null;
  parent_id?: string | null;
  priority?: number;
  progress?: number;
  progress_processed?: number;
  progress_total?: number;
  /**
   * @minItems 1
   */
  related_objects?: JobsRelatedObject[];
  started_at?: string;
  status:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
  steps?: JobsJobStep[];
  title: string;
  type:
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING';
}
/**
 * Original schema `JobStepElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobStepElasticSchema}
 */
export interface JobsJobStepElasticSchema {
  date_updated?: string;
  error_message?: string | null;
  id?: string;
  label: string;
  message?: string | null;
  status?: string;
}
/**
 * Original schema `JobStepSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobStepSchema}
 */
export interface JobsJobStepSchema {
  date_updated?: string;
  error_message?: string | null;
  id?: string;
  label: string;
  message?: string | null;
  status: 'IN_PROGRESS' | 'WAITING' | 'FAILED' | 'DONE' | 'SKIPPED';
}
/**
 * Original schema `JobStepUpdateBulkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobStepUpdateBulkSchema}
 */
export interface JobsJobStepUpdateBulkSchema {
  date_updated?: string;
  error_message?: string | null;
  id: string;
  label: string;
  message?: string | null;
  status: 'IN_PROGRESS' | 'WAITING' | 'FAILED' | 'DONE' | 'SKIPPED';
}
/**
 * Original schema `JobStepUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobStepUpdateSchema}
 */
export interface JobsJobStepUpdateSchema {
  date_updated?: string;
  error_message?: string | null;
  id?: string;
  label: string;
  message?: string | null;
  status: 'IN_PROGRESS' | 'WAITING' | 'FAILED' | 'DONE' | 'SKIPPED';
}
/**
 * Original schema `JobStepsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobStepsSchema}
 */
export interface JobsJobStepsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: JobsJobStepSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `JobStepsUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobStepsUpdateSchema}
 */
export interface JobsJobStepsUpdateSchema {
  steps: JobsJobStepUpdateBulkSchema[];
}
/**
 * Original schema `JobsBulkActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsBulkActionSchema}
 */
export interface JobsJobsBulkActionSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
}
/**
 * Original schema `JobsBulkDeleteParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsBulkDeleteParamsSchema}
 */
export interface JobsJobsBulkDeleteParamsSchema {
  _exists_?: string[];
  _missing_?: string[];
  created_by?: string[];
  date_created?: string;
  date_modified?: string;
  /**
   * @maxItems 500
   */
  ids?: string[];
  'metadata.automation_id'?: string;
  object_id?: string;
  parent_id?: string;
  query?: string;
  status?: (
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'SKIPPED'
    | 'FAILED'
    | 'DISCARDED'
    | 'ABORTED'
  )[];
  type?: (
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING'
  )[];
}
/**
 * Original schema `JobsBulkDeleteSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsBulkDeleteSchema}
 */
export interface JobsJobsBulkDeleteSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids?: string[];
}
/**
 * Original schema `JobsBulkEditParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsBulkEditParamsSchema}
 */
export interface JobsJobsBulkEditParamsSchema {
  _exists_?: string[];
  _missing_?: string[];
  created_by?: string[];
  date_created?: string;
  date_modified?: string;
  /**
   * @maxItems 500
   */
  ids?: string[];
  merge_metadata?: boolean;
  'metadata.automation_id'?: string;
  object_id?: string;
  parent_id?: string;
  query?: string;
  status?: (
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED'
  )[];
  type?: (
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING'
  )[];
}
/**
 * Original schema `JobsBulkEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsBulkEditSchema}
 */
export interface JobsJobsBulkEditSchema {
  error_message?: string;
  job_context?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata?: {
    [k: string]: unknown;
  };
  status?:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
}
/**
 * Original schema `JobsBulkParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsBulkParamsSchema}
 */
export interface JobsJobsBulkParamsSchema {
  _exists_?: string[];
  _missing_?: string[];
  created_by?: string[];
  date_created?: string;
  date_modified?: string;
  /**
   * @maxItems 500
   */
  ids?: string[];
  'metadata.automation_id'?: string;
  object_id?: string;
  parent_id?: string;
  query?: string;
  type?: (
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING'
  )[];
}
/**
 * Original schema `JobsPrioritySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsPrioritySchema}
 */
export interface JobsJobsPrioritySchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
  priority: number;
}
/**
 * Original schema `JobsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsQueryParamsSchema}
 */
export interface JobsJobsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  search_after?: unknown[] | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `JobsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsSchema}
 */
export interface JobsJobsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: JobsJobElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `JobsStateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsStateSchema}
 */
export interface JobsJobsStateSchema {
  action: 'PAUSE' | 'RESUME' | 'ABORT' | 'RESTART';
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-ListObjectsSchema}
 */
export interface JobsListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `ReindexJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-ReindexJobSchema}
 */
export interface JobsReindexJobSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `RelatedObjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-RelatedObjectSchema}
 */
export interface JobsRelatedObjectSchema {
  object_id: string;
  object_type: string;
}
/**
 * Original schema `JobsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobsSchema}
 */
export interface JobsJobsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: JobsJobElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `JobElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobElasticSchema}
 */
export interface JobsJobElasticSchemaWithIdNullable {
  action_context?: JobsActionContextSchema | null;
  children_progress?: {
    [k: string]: JobsJobChildProgressSchema;
  } | null;
  completed_at?: string | null;
  created_by?: string | null;
  custom_type?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  error_message?: string | null;
  has_children?: boolean | null;
  id: string;
  job_context?: {
    [k: string]: unknown;
  } | null;
  message?: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_id?: string | null;
  object_type?: string | null;
  parent_id?: string | null;
  priority?: number | null;
  progress?: number | null;
  progress_processed?: number | null;
  progress_total?: number | null;
  related_objects?: JobsRelatedObject[] | null;
  started_at?: string | null;
  status:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
  steps?: JobsJobStepElastic[] | null;
  storage_id?: string | null;
  title: string;
  type:
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING';
}
/**
 * Original schema `JobElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobElasticSchema}
 */
export interface JobsJobElasticSchemaWithId {
  action_context?: JobsActionContextSchema;
  children_progress?: {
    [k: string]: JobsJobChildProgressSchema;
  };
  completed_at?: string;
  created_by?: string;
  custom_type?: string | null;
  date_created?: string;
  date_modified?: string;
  error_message?: string;
  has_children?: boolean;
  id: string;
  job_context?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id?: string | null;
  object_type?: string | null;
  parent_id?: string | null;
  priority?: number;
  progress?: number;
  progress_processed?: number;
  progress_total?: number;
  /**
   * @minItems 1
   */
  related_objects?: JobsRelatedObject[];
  started_at?: string;
  status:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
  steps?: JobsJobStepElastic[];
  storage_id?: string;
  title: string;
  type:
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING';
}
/**
 * Original schema `JobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobSchema}
 */
export interface JobsJobSchemaWithId {
  action_context?: JobsActionContextSchema;
  children_progress?: {
    [k: string]: JobsJobChildProgressSchema;
  };
  completed_at?: string;
  created_by?: string;
  custom_type?: string | null;
  date_created?: string;
  date_modified?: string;
  error_message?: string;
  has_children?: boolean;
  id: string;
  job_context?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id?: string | null;
  object_type?: string | null;
  parent_id?: string | null;
  priority?: number;
  progress?: number;
  progress_processed?: number;
  progress_total?: number;
  /**
   * @minItems 1
   */
  related_objects?: JobsRelatedObject[];
  started_at?: string;
  status:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
  steps?: JobsJobStep[];
  title: string;
  type:
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING';
}
/**
 * Original schema `JobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#model-JobSchema}
 */
export interface JobsJobSchemaWithIdNullable {
  action_context?: JobsActionContextSchema | null;
  children_progress?: {
    [k: string]: JobsJobChildProgressSchema;
  } | null;
  completed_at?: string | null;
  created_by?: string | null;
  custom_type?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  error_message?: string | null;
  has_children?: boolean | null;
  id: string;
  job_context?: {
    [k: string]: unknown;
  } | null;
  message?: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_id?: string | null;
  object_type?: string | null;
  parent_id?: string | null;
  priority?: number | null;
  progress?: number | null;
  progress_processed?: number | null;
  progress_total?: number | null;
  related_objects?: JobsRelatedObject[] | null;
  started_at?: string | null;
  status:
    | 'READY'
    | 'STARTED'
    | 'FINISHED'
    | 'FINISHED_WITH_WARNING'
    | 'FAILED'
    | 'WAITING'
    | 'ABORT_PENDING'
    | 'ABORTED'
    | 'SKIPPED'
    | 'PAUSED'
    | 'PENDING_USER'
    | 'DISCARDED';
  steps?: JobsJobStep[] | null;
  title: string;
  type:
    | 'MEDIAINFO'
    | 'TRANSCODE'
    | 'KEYFRAMES'
    | 'EXPORT'
    | 'DELETE'
    | 'REINDEX'
    | 'MOVE'
    | 'TRANSFER'
    | 'ANALYZE'
    | 'METADATA'
    | 'CUSTOM'
    | 'SCAN'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ACL'
    | 'COPY'
    | 'TRANSCRIPTION'
    | 'REQUEST_COLLECTION_MAP'
    | 'COLLECTION_CUSTOM_ORDER'
    | 'STORAGE_GATEWAY_FILE_INGEST'
    | 'MARK_MISSING'
    | 'FACE_RECOGNITION'
    | 'SET_APPROVAL'
    | 'REQUEST_APPROVAL'
    | 'CHANGE_PERSON'
    | 'CONFIRM_PERSON'
    | 'DELETE_PERSON'
    | 'AUTOMATION'
    | 'REVIEW_REQUEST'
    | 'CONVERT_SAVED_SEARCH_TO_COLLECTION'
    | 'CONVERT_SEARCH_TO_COLLECTION'
    | 'DELETE_JOBS'
    | 'EDIT_JOBS'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'METADATA_FILLING';
}

export interface JobsHttpDeleteJobsQuery {
  /**
   * Filter by parent_id
   */
  parent_id?: string;
  /**
   * Filter by object_id
   */
  object_id?: string;
  /**
   * Filter by created_by
   */
  created_by?: string;
  /**
   * Filter by job status
   */
  status?: string;
  /**
   * Filter by job types
   */
  type?: string;
  /**
   * Filter by date_created. Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Begin timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: 2018-01-01T10:00:00Z;2018-01-01T15:00:00Z
   */
  date_created?: string;
  /**
   * Filter by date_modified Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Begin timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: *;1544450400
   */
  date_modified?: string;
  /**
   * Filter by any of the above with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s
   */
  ids?: string;
  /**
   * Gives an ability to retrieve jobs created by a specific automation
   */
  'metadata.automation_id'?: string;
  /**
   * Filter jobs that have no fields specified in _missing_ (comma separated)
   */
  _missing_?: string;
  /**
   * Filter jobs that have all fields specified in _exists_ (comma separated)
   */
  _exists_?: string;
}

/**
 * `DELETE /v1/jobs/`
 *
 * Delete multiple jobs
 *
 * Required roles:
 *  - can_delete_jobs
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/delete_v1_jobs_}
 */
export const httpDeleteJobs = (
  body: JobsJobsBulkDeleteSchema,
  query?: JobsHttpDeleteJobsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpDeleteJobs,
  method: httpMethod.delete,
  url: '/API/jobs/v1/jobs/',

  body,
  query,
  headers,
});

export interface JobsHttpGetJobsQuery {
  /**
   * If facets should be returned
   */
  facets?: boolean;
  /**
   * List of aggregation keys if facets is true
   */
  aggregations?: string;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one. Prefer `search_after` for iterating over large result sets.
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * Cursor based pagination. Pass the `search_after` value of the previous response back unchanged (a JSON-encoded list of sort values). Requires `sort` and cannot be combined with `scroll`. The `page` parameter is ignored and facets are not returned when `search_after` is provided.
   */
  search_after?: string;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * Filter by type
   */
  type?: string;
  /**
   * Filter by object_type
   */
  object_type?: string;
  /**
   * Filter by parent_id
   */
  parent_id?: string;
  /**
   * Filter by object_id
   */
  object_id?: string;
  /**
   * Filter by status
   */
  status?: string;
  /**
   * Filter by created_by
   */
  created_by?: string;
  /**
   * Filter by date_created. Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Either timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: 2018-01-01T10:00:00Z;2018-01-01T15:00:00Z
   */
  date_created?: string;
  /**
   * Filter by date_modified Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Either timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: *;1544450400
   */
  date_modified?: string;
  /**
   * Filter by any of the above with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
  /**
   * Gives an ability to retrieve jobs created by a specific automation
   */
  'metadata.automation_id'?: string;
  /**
   * Filter jobs by any field inside the metadata object. Any metadata field can be filtered this way by using the pattern metadata.<field>=value.
   * For example: metadata.transcoder_id=xyz
   */
  'metadata.<field>'?: string;
  /**
   * Filter jobs that have no fields specified in _missing_ (comma separated)
   */
  _missing_?: string;
  /**
   * Filter jobs that have all fields specified in _exists_ (comma separated)
   */
  _exists_?: string;
}

/**
 * `GET /v1/jobs/`
 *
 * Get list of jobs
 *
 * Required roles:
 *  - can_read_jobs
 *
 * Responses
 * - 200 - Returns a list of jobs
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link JobsJobsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/get_v1_jobs_}
 */
export const httpGetJobs = (
  query?: JobsHttpGetJobsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpGetJobs,
  method: httpMethod.get,
  url: '/API/jobs/v1/jobs/',

  query,
  headers,
});

export type JobsJobsBulkEditSchemaPartial = Partial<JobsJobsBulkEditSchema>;

export interface JobsHttpPatchJobsQuery {
  /**
   * Filter by parent_id
   */
  parent_id?: string;
  /**
   * Filter by object_id
   */
  object_id?: string;
  /**
   * Filter by created_by
   */
  created_by?: string;
  /**
   * Filter by job status
   */
  status?: string;
  /**
   * Filter by job types
   */
  type?: string;
  /**
   * Filter by date_created. Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Begin timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: 2018-01-01T10:00:00Z;2018-01-01T15:00:00Z
   */
  date_created?: string;
  /**
   * Filter by date_modified Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Begin timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: *;1544450400
   */
  date_modified?: string;
  /**
   * Filter by any of the above with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s
   */
  ids?: string;
  /**
   * Merge metadata in body with existing job metadata
   */
  merge_metadata?: boolean;
  /**
   * Gives an ability to retrieve jobs created by a specific automation
   */
  'metadata.automation_id'?: string;
  /**
   * Filter jobs that have no fields specified in _missing_ (comma separated)
   */
  _missing_?: string;
  /**
   * Filter jobs that have all fields specified in _exists_ (comma separated)
   */
  _exists_?: string;
}

/**
 * `PATCH /v1/jobs/`
 *
 * Edit jobs
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 202 - edit jobs scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link JobsBulkJobCreatedSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/patch_v1_jobs_}
 */
export const httpPatchJobs = (
  body: JobsJobsBulkEditSchemaPartial,
  query?: JobsHttpPatchJobsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPatchJobs,
  method: httpMethod.patch,
  url: '/API/jobs/v1/jobs/',

  body,
  query,
  headers,
});

/**
 * `POST /v1/jobs/`
 *
 * Create a new job
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 201 - Returns a created job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Parent job does not exist
 *
 * Response {@link JobsJobSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/post_v1_jobs_}
 */
export const httpPostJobs = (
  body: JobsJobCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPostJobs,
  method: httpMethod.post,
  url: '/API/jobs/v1/jobs/',

  body,
  headers,
});

/**
 * `PUT /v1/jobs/priority/`
 *
 * Change jobs priority
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/put_v1_jobs_priority_}
 */
export const httpPutJobsPriority = (
  body: JobsJobsPrioritySchema,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPutJobsPriority,
  method: httpMethod.put,
  url: '/API/jobs/v1/jobs/priority/',

  body,
  headers,
});

/**
 * `PUT /v1/jobs/state/`
 *
 * Change jobs state
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/put_v1_jobs_state_}
 */
export const httpPutJobsState = (
  body: JobsJobsStateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPutJobsState,
  method: httpMethod.put,
  url: '/API/jobs/v1/jobs/state/',

  body,
  headers,
});

export interface JobsHttpDeleteJobsByJobIdQuery {
  /**
   * If true, schedule recursive deletion of all child jobs and the job itself asynchronously; the job may remain until background processing completes.
   */
  recursive?: boolean;
}

/**
 * `DELETE /v1/jobs/{job_id}/`
 *
 * Delete a particular job by id
 *
 * Required roles:
 *  - can_delete_jobs
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/delete_v1_jobs__job_id__}
 */
export const httpDeleteJobsByJobId = (
  jobId: string,
  query?: JobsHttpDeleteJobsByJobIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpDeleteJobsByJobId,
  method: httpMethod.delete,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/`,
  params: { jobId },
  query,
  headers,
});

/**
 * `GET /v1/jobs/{job_id}/`
 *
 * Returns a particular job by id
 *
 * Required roles:
 *  - can_read_jobs
 *
 * Responses
 * - 200 - Returns a job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job does not exist
 *
 * Response {@link JobsJobSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/get_v1_jobs__job_id__}
 */
export const httpGetJobsByJobId = (
  jobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpGetJobsByJobId,
  method: httpMethod.get,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/`,
  params: { jobId },
  headers,
});

export type JobsJobSchemaPartial = Partial<JobsJobSchema>;

export interface JobsHttpPatchJobsByJobIdQuery {
  merge_metadata?: boolean;
}

/**
 * `PATCH /v1/jobs/{job_id}/`
 *
 * Update job
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Returns an updated job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job or parent job does not exist
 *
 * Response {@link JobsJobSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/patch_v1_jobs__job_id__}
 */
export const httpPatchJobsByJobId = (
  jobId: string,
  body: JobsJobSchemaPartial,
  query?: JobsHttpPatchJobsByJobIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPatchJobsByJobId,
  method: httpMethod.patch,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/`,
  params: { jobId },
  body,
  query,
  headers,
});

export interface JobsHttpPutJobsByJobIdQuery {
  merge_metadata?: boolean;
}

/**
 * `PUT /v1/jobs/{job_id}/`
 *
 * Update job
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Returns an updated job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job or parent job does not exist
 *
 * Response {@link JobsJobSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/put_v1_jobs__job_id__}
 */
export const httpPutJobsByJobId = (
  jobId: string,
  body: JobsJobSchema,
  query?: JobsHttpPutJobsByJobIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPutJobsByJobId,
  method: httpMethod.put,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/`,
  params: { jobId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/jobs/{job_id}/reindex/`
 *
 * Reindex job
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 202 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/post_v1_jobs__job_id__reindex_}
 */
export const httpPostJobsByJobIdReindex = (
  jobId: string,
  body: JobsReindexJobSchema,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPostJobsByJobIdReindex,
  method: httpMethod.post,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/reindex/`,
  params: { jobId },
  body,
  headers,
});

export type JobsJobStepsUpdateSchemaPartial = Partial<JobsJobStepsUpdateSchema>;

/**
 * `PATCH /v1/jobs/{job_id}/steps/`
 *
 * Update multiple job steps
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Returns an updated job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job or job step does not exist
 *
 * Response {@link JobsJobSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/patch_v1_jobs__job_id__steps_}
 */
export const httpPatchJobsByJobIdSteps = (
  jobId: string,
  body: JobsJobStepsUpdateSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPatchJobsByJobIdSteps,
  method: httpMethod.patch,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/steps/`,
  params: { jobId },
  body,
  headers,
});

/**
 * `PUT /v1/jobs/{job_id}/steps/`
 *
 * Update multiple job steps
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Returns an updated job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job or job step does not exist
 *
 * Response {@link JobsJobSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/put_v1_jobs__job_id__steps_}
 */
export const httpPutJobsByJobIdSteps = (
  jobId: string,
  body: JobsJobStepsUpdateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPutJobsByJobIdSteps,
  method: httpMethod.put,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/steps/`,
  params: { jobId },
  body,
  headers,
});

export type JobsJobStepUpdateSchemaPartial = Partial<JobsJobStepUpdateSchema>;

/**
 * `PATCH /v1/jobs/{job_id}/steps/{job_step_id}/`
 *
 * Update job step
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Returns an updated job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job or job step does not exist
 *
 * Response {@link JobsJobSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/patch_v1_jobs__job_id__steps__job_step_id__}
 */
export const httpPatchJobsByJobIdStepsByJobStepId = (
  jobId: string,
  jobStepId: string,
  body: JobsJobStepUpdateSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPatchJobsByJobIdStepsByJobStepId,
  method: httpMethod.patch,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/steps/${encodeURIComponent(jobStepId)}/`,
  params: { jobId, jobStepId },
  body,
  headers,
});

/**
 * `PUT /v1/jobs/{job_id}/steps/{job_step_id}/`
 *
 * Update job step
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Returns an updated job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Job or job step does not exist
 *
 * Response {@link JobsJobSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/jobs/spec/#/default/put_v1_jobs__job_id__steps__job_step_id__}
 */
export const httpPutJobsByJobIdStepsByJobStepId = (
  jobId: string,
  jobStepId: string,
  body: JobsJobStepUpdateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: JobsHttpPutJobsByJobIdStepsByJobStepId,
  method: httpMethod.put,
  url: `/API/jobs/v1/jobs/${encodeURIComponent(jobId)}/steps/${encodeURIComponent(jobStepId)}/`,
  params: { jobId, jobStepId },
  body,
  headers,
});
